import type { RivalStyle } from './types.js';

export const NIGHT_TOUR_ID = 'city-lights' as const;
export const STREET_TOUR_IDS = ['city-lights', 'mountain-pulse', 'outlaw-frequency'] as const;
export type StreetTourId = typeof STREET_TOUR_IDS[number];

export const NIGHT_TOUR_RIVALS = [
  { name: 'Nova', style: 'grip' },
  { name: 'Jax', style: 'bully' },
  { name: 'Sora', style: 'drift' },
  { name: 'Mika', style: 'sprinter' },
  { name: 'Rook', style: 'grip' },
  { name: 'Inez', style: 'trickster' },
  { name: 'Tao', style: 'drift' },
  { name: 'Lux', style: 'sprinter' },
  { name: 'Vega', style: 'bully' },
  { name: 'Remy', style: 'drift' },
  { name: 'Kian', style: 'trickster' },
  { name: 'Nyx', style: 'sprinter' },
] as const satisfies readonly { name: string; style: RivalStyle }[];

export function nightTourRivalStyle(nameValue: string): RivalStyle | null {
  const name = nameValue.trim().toLocaleLowerCase();
  return NIGHT_TOUR_RIVALS.find((rival) => rival.name.toLocaleLowerCase() === name)?.style ?? null;
}

export function isNightTourRivalName(name: string): boolean {
  return nightTourRivalStyle(name) !== null;
}

export function isStreetTourId(value: unknown): value is StreetTourId {
  return typeof value === 'string' && (STREET_TOUR_IDS as readonly string[]).includes(value);
}
